import React from 'react';
import {
  SIA_FOLLOWUP_COMPLETED_NOTIF_URL_PARAM,
  SIA_PERSONAL_LINES_COMPLETED_NOTIF_URL_PARAM,
} from '@/utils/constants/sia';
import { timeAgo } from '@/utils/ts/stringUtils';
import { INotification } from '@Saral-Influencer-Marketing/saral-utils/src/models';

import RightArrow from '@/components/Icons/icons/RightArrow';

import ButtonComponent from '../../ButtonComponent/ButtonComponent';

interface Props {
  notification: INotification;
  setShowNotificationDropdown: React.Dispatch<React.SetStateAction<boolean>>;
  markSingleNotificationAsSeen: () => void;
}

const PersonalLinesGenerationCompleted = ({
  notification,
  setShowNotificationDropdown,
  markSingleNotificationAsSeen,
}: Props) => {
  return (
    <div className={`single-notification ${notification.seen && 'seen'}`}>
      <div className="unread-dot"></div>
      <div className="w-9 h-9 flex-shrink-0 text-xl flex center items-center">✨</div>
      <div className="text-div ">
        <h3 className="text-base font-medium text-default">{notification?.title}</h3>
        <p className="text-sm font-normal text-subdued">{notification?.content?.message}</p>

        <div className="mt-2">
          <ButtonComponent
            variant="text-highlight"
            className="p-0"
            onClick={() => {
              markSingleNotificationAsSeen();
              setShowNotificationDropdown(false);
              if (notification?.content?.listId) {
                window.location.href = `/dashboard/list/detail/${notification?.content?.listId}?tab=active-creators&page=1&${SIA_PERSONAL_LINES_COMPLETED_NOTIF_URL_PARAM}=true`;
              }

              if (notification?.content?.campaignId) {
                window.location.href = `/dashboard/email-templates/${notification?.content?.campaignId}?${SIA_PERSONAL_LINES_COMPLETED_NOTIF_URL_PARAM}=true`;
              }

              if (notification?.content?.threadIds) {
                window.location.href = `/dashboard/inbox?${SIA_FOLLOWUP_COMPLETED_NOTIF_URL_PARAM}=true&notificationId=${notification?._id}`;
              }
            }}
            rightIcon={<RightArrow color="var(--text-highlight)" />}>
            <span className="text-sm">Review Now</span>
          </ButtonComponent>
        </div>
        <p className="timestamp pt-2">{timeAgo(notification?.createdAt.toString())}</p>
      </div>
    </div>
  );
};

export default PersonalLinesGenerationCompleted;
